import Marionette from "backbone.marionette";

export default Backbone.Collection.extend({
    url: "api/translations/index.php"
});


//////////////////
// WEBPACK FOOTER
// ./app/collections/translationsCollection.js
// module id = 169
// module chunks = 0